import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from '../components/error/error_404.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = '#app'
  const app = new Vue({
    el,
    render: h => h(App)
  })
})
